import React, { useState, useEffect } from 'react'
import { CHARGE_CDN, HOME_PILE_SHARE_VERSION } from '../../../../utils/constants';
import Toast from '@xpeng/rc-toast';

import qrcode from 'qrcode';
import SharingCloseModal from '../sharing-close-modal';
import SharingMessageModal from '../sharing-message-modal';
import StationCodeModal from '../station-code-modal';
import { goToNativePage, goToPage, isNowVersionUpOrMatch, goBack } from '../../../../utils/common';
import { queryShareApplyInfo, getIncomeList } from '../../api';
import { trackGdp } from '../../../../utils/gio-report';
import { UserTypeEnum } from '../../../../api/pile';
import { OrderStatusEnum } from '../../types';

import './index.less'
import { removeStationDtl } from '../../shared/cache';

interface SharingHeaderPropsRule {
  data: any
  stationId?: string
  pileInfoData: any
  incomeTotal: {
    incomeAmt: string
    orderCount: string
  }
  userInfo: any
  firstThreeTipsInfo: {
    visible: boolean
    text: string
  }
  onShare: () => void
}

function SharingHeader(props: SharingHeaderPropsRule) {
  const {
    stationId, data, pileInfoData, incomeTotal, userInfo, firstThreeTipsInfo, onShare
  } = props

  const [actionsListShow, setActionsListShow] = useState<boolean>(false)
  const [closeVisible, setCloseVisible] = useState<boolean>(false)
  const [msgModalInfo, setMsgModalInfo] = useState<any>({})
  const [stationCodeModalVisible, setStationCodeModalVisible] = useState<boolean>(false)
  const [stationOfflineCode, setStationOfflineCode] = useState<string>('')
  // 保持线下码红点flag
  const hasClickedSaveOfflineCode = !!localStorage.getItem(`${userInfo?.uid}_hasClickedSaveOfflineCode`)
  // const [showRedPointOfSaveOfflineCode, setShowRedPointOfSaveOfflineCode] = useState<boolean>(!hasClickedSaveOfflineCode)

  // 修改信息红点flag
  const HasClickedSettingKey = `pile_sharing_manage_${userInfo?.uid}_hasClickedSetting`
  const hasClickedSetting = !!localStorage.getItem(HasClickedSettingKey);
  const [showRedPointOfHasClickedSettinge, setShowRedOfHasClickedSettinge] = useState<boolean>(!hasClickedSetting)

  const isCloseShare = data?.operationDto?.stationStatus === '03'
  const versionMark = isNowVersionUpOrMatch(HOME_PILE_SHARE_VERSION) // 版本判断

  useEffect(() => {
    if (!isCloseShare) {
      trackGdp('P20075', 'B004', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type]
      })
      trackGdp('P20075', 'B012', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type]
      })
    } else {
      trackGdp('P20075', 'B014', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type]
      })
    }

    document.addEventListener('click', afterClick)
    return () => {
      document.removeEventListener('click', afterClick)
    }
  }, [])

  useEffect(() => {
    if (actionsListShow && !isCloseShare) {
      trackGdp('P20075', 'B025', {
        userType: UserTypeEnum[userInfo?.type],
        'user_type': UserTypeEnum[userInfo?.type],
      })
    }
  }, [actionsListShow])

  const afterClick = e => {
    // @ts-ignore
    if (e?.target?.id !== 'action') {
      setActionsListShow(false)
    }
  }

  const jumpToRewrite = async () => {
    let userApplyRes = await queryShareApplyInfo({
      pileNo: pileInfoData?.pileNo,
      applyType: isCloseShare ? 1 : 2
    })
    if (userApplyRes?.code === 200) {
      if (userApplyRes.data?.applyStatus === 1) {
        Toast.show('当前有申请正在审核中')
      } else {
        localStorage.setItem(HasClickedSettingKey, 'true')
        setShowRedOfHasClickedSettinge(false)
        const { origin, pathname } = window.location
        goToPage(`${origin}${pathname.replace('pile-sharing-manage.html', 'pile-sharing.html')}#/apply?applyType=2&pileNo=${pileInfoData?.pileNo}`)
      }
    }
  }

  const reopen = () => {
    trackGdp('P20075', 'B015', {
      userId: userInfo?.uid,
      userType: UserTypeEnum[userInfo?.type],
      'user_type': UserTypeEnum[userInfo?.type],
    })
    if (!pileInfoData?.hasPile) {
      trackGdp('P20075', 'B019', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type],
        'user_type': UserTypeEnum[userInfo?.type],
      })
      setMsgModalInfo({
        confirmText: '去购买',
        cancelText: '好的',
        visible: true,
        text: '只有拥有小鹏家充桩的用户可开通共享，你当前没有家充桩',
        onCancel: goBack,
        onConfirm: () => {
          trackGdp('P20075', 'B020', {
            userId: userInfo?.uid,
            userType: UserTypeEnum[userInfo?.type],
            'user_type': UserTypeEnum[userInfo?.type]
          })
          window.location.href = 'https://mall.xiaopeng.com/product/1530137912979308545?entry=300059'
        }
      })
    } else {
      const { origin, pathname } = window.location
      stationId && removeStationDtl(stationId)
      window.location.href = `${origin}${pathname.replace('pile-sharing-manage.html', 'pile-sharing.html')}#/apply?applyType=1&pileNo=${pileInfoData?.pileNo}&reopen=true${stationId ? `&stationId=${stationId}` : ''}`
    }
  }

  const openShare = async () => {
    trackGdp('P20075', 'B013', {
      userId: userInfo?.uid,
      userType: UserTypeEnum[userInfo?.type],
      'user_type': UserTypeEnum[userInfo?.type]
    })
    onShare && onShare()
  }

  const closeShare = async () => {
    try {
      const res = await getIncomeList({
        stationId: stationId,
        pageNo: 1,
        pageSize: 10,
        orderStatusList: [
          OrderStatusEnum.SETTLEMENT,
          OrderStatusEnum.TO_BE_SETTLED,
          OrderStatusEnum.TO_BE_USED,
          OrderStatusEnum.USING
        ]
      })
      if (res.code === 200) {
        const { data } = res
        if (data?.total > 0) {
          setMsgModalInfo({
            visible: true,
            title: '有未完成的订单',
            text: '站点当前有未结束的订单，请待订单完成后再操作',
            confirmText: '好的',
            onConfirm: () => {
              setMsgModalInfo({ visible: false })
            },
            withoutCancel: true
          })
        } else {
          setCloseVisible(true)
        }
      }
    } catch (error) {
      console.log('closeShare error', error)
    }
  }

  const generatePoster = (): Promise<string> => {
    // 绘制文本
    const drawText = (context, text, color, x, y, font) => {
      context.font = font;
      context.fillStyle = color;
      context.fillText(text, x, y);
    }

    // 绘制矩形
    const drawRect = (context, color, x, y, w, h, lineWidth = '1') => {
      context.beginPath();
      context.lineWidth = lineWidth;
      context.strokeStyle = color;
      context.rect(x, y, w, h);
      context.fillStyle = color;
      context.fillRect(x, y, w, h);
      context.stroke();
      context.closePath()
    }

    return new Promise(async (resolve, reject) => {
      const canvas = document.createElement('canvas');
      const ratio = (window.devicePixelRatio || 1) + 1;
      canvas.width = 654 * ratio;
      canvas.height = 924 * ratio;
      const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
      ctx.scale(ratio, ratio)

      // 首先清空画布
      ctx.clearRect(0, 0, 654, 924);
      ctx.save();

      const logoImg = new Image();
      logoImg.crossOrigin = 'anonymous';
      logoImg.onerror = reject;
      await new Promise((resolve) => {
        logoImg.onload = resolve
        logoImg.src = `${CHARGE_CDN}/sharing/offline_code_logo.png`
      })

      const titleImg = new Image();
      titleImg.crossOrigin = 'anonymous';
      titleImg.onerror = reject;
      await new Promise((resolve) => {
        titleImg.onload = resolve
        titleImg.src = `${CHARGE_CDN}/sharing/offline_code_tips.png`
      })

      const centerImg = new Image();
      centerImg.crossOrigin = 'anonymous';
      centerImg.onerror = reject;
      await new Promise((resolve) => {
        centerImg.onload = resolve
        centerImg.src = `${CHARGE_CDN}/sharing/offline_code_center.png`
      })

      const payImg = new Image();
      payImg.crossOrigin = 'anonymous';
      payImg.onerror = reject;
      await new Promise((resolve) => {
        payImg.onload = resolve
        payImg.src = `${CHARGE_CDN}/sharing/offline_code_pay_methods.png`
      })

      const guideImg = new Image();
      guideImg.crossOrigin = 'anonymous';
      guideImg.onerror = reject;
      await new Promise((resolve) => {
        guideImg.onload = resolve
        guideImg.src = `${CHARGE_CDN}/sharing/offline_code_guide.png`
      })

      const qrCodeImg = new Image();
      const qrCodeUrl = data?.operationDto?.stationQrCode ? `${data?.operationDto?.stationQrCode}&origin=4` : 'https://www.xiaopeng.com/'

      await qrcode.toDataURL(
        qrCodeUrl,
        { margin: 0 },
        (err, res) => {
          if (err) {
            console.log('qrcode.toDataURL error', err)
            return
          }
          qrCodeImg.src = res

          qrCodeImg.onload = () => {
            // 缩放后单位像素
            const unitPx = canvas.width / ratio / 654

            drawRect(ctx, '#F9F9F9', 0, 0, unitPx * 654, unitPx * 924);
            ctx.drawImage(logoImg, unitPx * 47, unitPx * 32, unitPx * 60, unitPx * 32);
            ctx.drawImage(titleImg, unitPx * 120, unitPx * 77, unitPx * 428, unitPx * 50);
            drawText(ctx, '支持所有国标新能源车使用', '#F58900', unitPx * 220, unitPx * 166, '18px PingFang SC');
            drawRect(ctx, '#FFFFFF', unitPx * 157, unitPx * 208, unitPx * 340, unitPx * 340);
            ctx.drawImage(qrCodeImg, unitPx * 170, unitPx * 220, unitPx * 320, unitPx * 320);
            // ctx.drawImage(centerImg, unitPx * 282, unitPx * 334, unitPx * 90, unitPx * 90);
            ctx.drawImage(payImg, unitPx * 198, unitPx * 560, unitPx * 260, unitPx * 38);
            ctx.drawImage(guideImg, unitPx * 101, unitPx * 604, unitPx * 450, unitPx * 287);

            resolve(canvas.toDataURL(`image/jpeg`, 0.4))
          }
        }
      )
    })
  }

  // const showOfflineCodeModal = async () => {
  //   const qrCode = await generatePoster()

  //   setStationOfflineCode(qrCode)
  //   setStationCodeModalVisible(true)

  //   localStorage.setItem(`${userInfo?.uid}_hasClickedSaveOfflineCode`, 'true')
  //   setShowRedPointOfSaveOfflineCode(false)
  // }

  const goToCashOutIncome = () => {
    trackGdp('P20075', 'B044', {
      userType: UserTypeEnum[userInfo?.type],
    })

    const { origin, pathname } = window.location
    goToPage(`${origin}${pathname}#/income`)
  }

  const clickHeader = () => {
    // 站点未关闭且满足版本要求
    if (!isCloseShare && versionMark > -1) {
      trackGdp('P20075', 'B005', {
        userId: userInfo?.uid,
        userType: UserTypeEnum[userInfo?.type]
      })

      const urlConfig = {
        app: `xiaopeng://xrn/dynamicPage?launchPage=XPMotors_ReactNativeHomePileStationDetail&stationId=${stationId}`,
        mini: `/pages/home-pile-station-detail/index?stationId=${stationId}`
      }
      goToNativePage(urlConfig)
    }
  }

  return <>
    <div
      className={`sharing-header ${isCloseShare ? 'sharing-header-grey' : ''}`}
      onClick={clickHeader}
    >
      <div className='title'>
        <div className={`title-left ${isCloseShare ? 'title-left-grey' : ''}`}>
          {data?.baseDto?.stationName || '--'}
        </div>
        {isCloseShare && <div className='has-stop-sharing'>已关闭共享</div>}
      </div>
      <div className='income-info-wrap'>
        <div className='cumulative-income'>
          <div className='value'>
            <div className='num'>{incomeTotal.incomeAmt || 0}</div>
            <div className='unit'>元</div>
          </div>
          <div className='title'>累计收益</div>
        </div>
        <div className='devide-line'></div>
        <div className='cumulative-income'>
          <div className='value'>
            <div className='num'>{incomeTotal.orderCount || 0}</div>
            <div className='unit'>次</div>
          </div>
          <div className='title'>帮助他人</div>
        </div>
      </div>
      <div className='action-bottom'>
        <div
          className='invite-btn'
          onClick={(e) => {
            e.preventDefault()
            e.stopPropagation()
            isCloseShare ? reopen() : openShare()
          }}
        >
          {!isCloseShare && <img className='invite-icon' alt="" src={`${CHARGE_CDN}/sharing/share.png`} />}
          <div className='invite-text'>{isCloseShare ? '重新开启共享' : '邀请他人来充电'}</div>
        </div>
        {!isCloseShare && (
          <div
            className='more-trigger'
            id='action'
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setActionsListShow(!actionsListShow)
              !actionsListShow && trackGdp('P20075', 'B006', {
                userId: userInfo?.uid,
                userType: UserTypeEnum[userInfo?.type],
                'user_type': UserTypeEnum[userInfo?.type],
              })
              !actionsListShow && trackGdp('P20075', 'B010', {
                userId: userInfo?.uid,
                userType: UserTypeEnum[userInfo?.type],
                'user_type': UserTypeEnum[userInfo?.type],
              })
            }}
          >
            <img className='more-icon' id='action' alt="" src={`${CHARGE_CDN}/sharing/more.png`} />
            {/* {showRedPointOfSaveOfflineCode && <div className='red-point'></div>} */}
          </div>
        )}
        <div className={`float-actions-list ${actionsListShow ? 'show' : ''}`}>
          {/* <div
            className='action'
            id='action' 
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              setActionsListShow(false)
              goToCashOutIncome()
            }}
          >收入提现</div> */}
          {
            !isCloseShare && <div>
              {/* <div
                className='action'
                id='action'
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  setActionsListShow(false)
                  showOfflineCodeModal()
                  trackGdp('P20075', 'B026', {
                    userType: UserTypeEnum[userInfo?.type],
                    'user_type': UserTypeEnum[userInfo?.type],
                  })
                }}
              >
                保存线下码
                {showRedPointOfSaveOfflineCode && <div className='red-point'></div>}
              </div> */}
              <div
                className='action'
                id='action'
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  trackGdp('P20075', 'B011', {
                    userId: userInfo?.uid,
                    userType: UserTypeEnum[userInfo?.type]
                  })
                  setActionsListShow(false)
                  jumpToRewrite()
                }}
              >
                修改信息
                {/* {showRedPointOfHasClickedSettinge && <div className='red-point'></div>} */}
              </div>
              <div
                className='action'
                id='action'
                onClick={(e) => {
                  e.preventDefault()
                  e.stopPropagation()
                  trackGdp('P20075', 'B007', {
                    userId: userInfo?.uid,
                    userType: UserTypeEnum[userInfo?.type]
                  })
                  setActionsListShow(false)
                  closeShare()
                }}
              >关闭共享</div>
            </div>
          }
        </div>
      </div>

      {
        firstThreeTipsInfo.visible ? (
          <div
            className='first-three-sharing-tips'
            onClick={(e) => {
              e.stopPropagation()
              e.preventDefault()
              onShare && onShare()
              trackGdp('P20075', 'B036', {
                content: firstThreeTipsInfo.text
              })
            }}
          >
            <div className='arrow-up'></div>
            <div className='text'>{firstThreeTipsInfo.text}</div>
          </div>
        ) : null
      }
    </div>

    <SharingCloseModal
      stationId={stationId}
      visible={closeVisible}
      setVisible={setCloseVisible}
      incomeTotal={incomeTotal}
      userInfo={userInfo}
    />

    <SharingMessageModal
      title={msgModalInfo.title}
      confirmText={msgModalInfo.confirmText}
      cancelText={msgModalInfo.cancelText}
      visible={msgModalInfo.visible}
      text={msgModalInfo.text}
      onCancel={msgModalInfo.onCancel}
      onConfirm={msgModalInfo.onConfirm}
      withoutCancel={msgModalInfo.withoutCancel}
    />

    {/* 桩主给出去的二维码加个参数origin=4 在站详页曝光埋点用于统计入口来源 */}
    <StationCodeModal
      visible={stationCodeModalVisible}
      onClose={() => setStationCodeModalVisible(false)}
      qrCode={stationOfflineCode}
    />

  </>
}

export default SharingHeader